module.exports = __webpack_public_path__ + "static/media/BALNCE-TE-MAYO copia.9b91f139.webp";